"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var test_attributes_1 = require("@carvana/test-attributes");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var Slider_styles_1 = require("./Slider.styles");
var SliderThumb_1 = require("./SliderThumb");
var useControllableState_1 = require("./useControllableState");
var SlideDirection;
(function (SlideDirection) {
    SlideDirection[SlideDirection["INCREASING"] = 1] = "INCREASING";
    SlideDirection[SlideDirection["DECREASING"] = -1] = "DECREASING";
})(SlideDirection || (SlideDirection = {}));
var clampBetween = function (_a) {
    var min = _a[0], max = _a[1];
    return function (value) {
        return Math.min(max, Math.max(min, value));
    };
};
var getDecimalCount = function (value) { return (value.toString().split('.')[1] || '').length; };
var roundToPlaceCount = function (value, roundTo) {
    var decimalPlaces = Math.pow(10, roundTo);
    return Math.round(value * decimalPlaces) / decimalPlaces;
};
var linearScale = function (input, output) { return function (value) {
    var scaleRatio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + scaleRatio * (value - input[0]);
}; };
var sort = function (arr) { return __spreadArray([], arr, true).sort(function (a, b) { return a - b; }); };
var hasThumbPassedOtherThumb = function (values) { return values[0] > values[1]; };
var getStepDirection = function (nextValue, previousValues, activeIndex) {
    var previousValue = previousValues[activeIndex];
    return nextValue > previousValue ? SlideDirection.INCREASING : SlideDirection.DECREASING;
};
exports.Slider = (0, react_1.forwardRef)(function (_a, forwardedRef) {
    var className = _a.className, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.max, max = _c === void 0 ? 100 : _c, _d = _a.min, min = _d === void 0 ? 0 : _d, _e = _a.minStepsBetweenValues, minStepsBetweenValues = _e === void 0 ? 0 : _e, _f = _a.step, step = _f === void 0 ? 1 : _f, testId = _a.testId, _g = _a.thumbBehavior, thumbBehavior = _g === void 0 ? 'slide-together' : _g, _h = _a.transformMinStepsConvergence, transformMinStepsConvergence = _h === void 0 ? false : _h, _j = _a.withTrack, withTrack = _j === void 0 ? true : _j, _k = _a.onValueChange, onValueChange = _k === void 0 ? function () { } : _k, _l = _a.onValueCommit, onValueCommit = _l === void 0 ? function () { } : _l, props = __rest(_a, ["className", "disabled", "max", "min", "minStepsBetweenValues", "step", "testId", "thumbBehavior", "transformMinStepsConvergence", "withTrack", "onValueChange", "onValueCommit"]);
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    var dataTestId = function (name) { return "".concat(testId ? "".concat(testId, "-") : '', "slider-").concat(name); };
    var indexRef = (0, react_1.useRef)(0);
    var sliderRef = (0, react_1.useRef)(null);
    var thumbRefs = (0, react_1.useRef)([]);
    var clamp = (0, react_1.useCallback)(function (value) { return clampBetween([min, max])(value); }, [min, max]);
    var isControlled = props.value ? props.value.length > 0 : false;
    var toSafeDecimalPlace = (0, react_1.useCallback)(function (val) {
        var decimals = getDecimalCount(step);
        var rounded = roundToPlaceCount(val, decimals);
        return clamp(rounded);
    }, [min, max, step, clamp]);
    /**
     * Outputs the internal state to callbacks. Transforms the value
     * if necessary when `transformMinStepsConvergence` is set.
     */
    var applyOutputTransformations = (0, react_1.useCallback)(function (values) {
        var sorted = isControlled ? values : sort(values);
        if (!transformMinStepsConvergence)
            return sorted.map(toSafeDecimalPlace);
        var leftThumbScaler = linearScale([min, max - minStepsBetweenValues * step], [min, max]);
        var rightThumbScaler = linearScale([max, min + minStepsBetweenValues * step], [max, min]);
        var leftScaled = clamp(leftThumbScaler(sorted[0]));
        var rightScaled = clamp(rightThumbScaler(sorted[sorted.length - 1]));
        return [leftScaled, rightScaled]
            .map(function (val) {
            var decimals = getDecimalCount(val);
            var stepTo = min + step * Math.round((val - min) / step);
            var rounded = roundToPlaceCount(stepTo, decimals);
            return clamp(rounded);
        })
            .map(toSafeDecimalPlace);
    }, [
        clamp,
        isControlled,
        max,
        min,
        minStepsBetweenValues,
        step,
        transformMinStepsConvergence,
        toSafeDecimalPlace
    ]);
    var validateProps = function () {
        return ({
            defaultValue: props.defaultValue ? props.defaultValue.map(clamp) : [min],
            value: props.value ? props.value.map(clamp) : undefined
        });
    };
    var _m = validateProps(), defaultValue = _m.defaultValue, value = _m.value;
    var _o = (0, useControllableState_1.useControllableState)({
        defaultValue: defaultValue,
        value: value,
        onChange: function (state) {
            onValueChange(applyOutputTransformations(state));
        }
    }), controlledValue = _o[0], setControlledValue = _o[1];
    var previousValueRef = (0, react_1.useRef)(controlledValue);
    // Expose internals to our forwarded ref.
    (0, react_1.useImperativeHandle)(forwardedRef, function () { return ({
        value: applyOutputTransformations(controlledValue),
        focus: function (options) {
            sliderRef.current.focus(options);
        }
    }); }, [applyOutputTransformations, controlledValue]);
    var getFraction = (0, react_1.useCallback)(function (v) { return (v - min) / (max - min); }, [max, min]);
    var moveThumbToValuePosition = (0, react_1.useCallback)(function (inputValue, atIndex, node) {
        var currentThumb = node !== null && node !== void 0 ? node : thumbRefs.current[atIndex];
        var width = currentThumb.getBoundingClientRect().width;
        var fraction = getFraction(inputValue);
        var offset = "".concat(width / 2 - width * fraction, "px");
        var percentage = "".concat(fraction * 100, "%");
        currentThumb.style.setProperty('--slider-dx', percentage);
        currentThumb.style.setProperty('--slider-dx-offset', offset);
    }, [getFraction]);
    (0, react_1.useEffect)(function () {
        controlledValue.forEach(function (nextValue, index) {
            moveThumbToValuePosition(nextValue, index);
        });
    }, [controlledValue, moveThumbToValuePosition]);
    /**
     * Calls onValueCommit callback when an active event handler stops
     * and the current thumb has updated its value.
     */
    var handleOnValueCommit = function () {
        var previousValue = previousValueRef.current[indexRef.current];
        var nextValue = controlledValue[indexRef.current];
        if (previousValue !== nextValue) {
            onValueCommit(applyOutputTransformations(controlledValue));
        }
    };
    var hydrateValues = function (previousValues, shouldCommit) { return function (nextValues) {
        if (shouldCommit)
            handleOnValueCommit();
        if (previousValues.toString() === nextValues.toString())
            return previousValues;
        return nextValues;
    }; };
    var slideTogether = function (nextValue, updateIndex, previousValues, nextValues) {
        if (thumbBehavior !== 'slide-together')
            return previousValues;
        var stepDirection = getStepDirection(nextValue, previousValues, updateIndex);
        var minSteps = minStepsBetweenValues * step;
        var nextValueStep = clamp(nextValue + stepDirection * minSteps);
        var hasEnoughBufferGap = Math.abs(nextValueStep - nextValue) === minSteps;
        if (hasEnoughBufferGap) {
            var otherIndex_1 = 1 - updateIndex;
            return nextValues.map(function (v, index) { return (index === otherIndex_1 ? nextValueStep : v); });
        }
        return previousValues;
    };
    var updateInput = function (nextValue, updateIndex, _a) {
        var _b = _a === void 0 ? { shouldCommit: false } : _a, shouldCommit = _b.shouldCommit;
        setControlledValue(function (previousValues) {
            var updateValues = hydrateValues(previousValues, shouldCommit);
            var nextValues = previousValues.map(function (previousValue, index) {
                return index === updateIndex ? nextValue : previousValue;
            });
            if (previousValues.length <= 1)
                return updateValues(nextValues);
            var otherIndex = 1 - updateIndex;
            var otherValue = previousValues[otherIndex];
            // Increase the active thumb z-index so it's always above the other.
            thumbRefs.current[updateIndex].style['z-index'] = '2';
            thumbRefs.current[otherIndex].style['z-index'] = '1';
            var isBetweenMinStepsBuffer = Math.abs(nextValue - otherValue) < minStepsBetweenValues * step;
            // This is the case where there's a required gap between the thumbs and we want to
            // slide together the handles as one is moving along the slider.
            if (isBetweenMinStepsBuffer) {
                nextValues = slideTogether(nextValue, updateIndex, previousValues, nextValues);
                if (nextValues === previousValues)
                    return previousValues;
            }
            // When dragging, the actual value will get out of order in the array, which is
            // an indicator that our current thumb has dragged over the other thumb. Therefore,
            // we either wamt to stop the thumb at the converge in case of stop-slide behavior or
            // slide together the values. Ignore for slide-through behavior.
            if (hasThumbPassedOtherThumb(nextValues) && thumbBehavior !== 'slide-through') {
                nextValues = slideTogether(nextValue, updateIndex, previousValues, nextValues);
                if (nextValues === previousValues)
                    return previousValues;
            }
            return updateValues(nextValues);
        });
    };
    /**
     * Translates a raw x-position from an event handler to a whole value
     * somewhere along the input slider.
     * @param pointerPosition The clientX position of the pointer.
     * @returns
     */
    var getPointerValue = function (pointerPosition) {
        var _a = sliderRef.current.getBoundingClientRect(), left = _a.left, width = _a.width;
        // This will scale some positional x-value along the
        // length of the "input" track to be contained within
        // a scaled range of [min, max]. The scaled value can
        // be greater than max, at which point it needs to be
        // clamped down to the max value.
        var scale = linearScale([0, width], [min, max]);
        var scaledValue = scale(pointerPosition - left);
        var decimalCount = getDecimalCount(scaledValue);
        // Snap to an input value that corresponds to the
        // physical pointer value. Returns a float value.
        var stepTo = min + step * Math.round((scaledValue - min) / step);
        // Returns an integer value
        var rounded = roundToPlaceCount(stepTo, decimalCount);
        return clamp(rounded);
    };
    /**
     * In a dual slider situation, when the input slider is clicked,
     * we want to move the closest thumb to that clicked pointerPosition.
     * @param pointerPosition
     * @returns
     */
    var getClosestIndexToUpdate = function (pointerPosition) {
        // There **should** be only one index in this case
        if (controlledValue.length <= 1)
            return 0;
        var nextValue = getPointerValue(pointerPosition);
        var leftEdgeValue = controlledValue[0];
        var leftMagnitude = Math.abs(nextValue - leftEdgeValue);
        var rightEdgeValue = controlledValue[controlledValue.length - 1];
        var rightMagnitude = Math.abs(nextValue - rightEdgeValue);
        // Use the default value ref value in this case.
        if (leftMagnitude === rightMagnitude) {
            return indexRef.current;
        }
        // If the right thumb is further away from the clicked value,
        // then the closest is the left thumb (which **should** be 0) and vice-versa.
        return rightMagnitude > leftMagnitude ? 0 : 1;
    };
    /**
     * Updates the next step for a keyboard event. Slide-through keyboard
     * behavior is tricky to handle inside the updateValue function,
     * so we have to do the calculation here.
     * @param sign
     * @returns
     */
    var getNextStep = function (sign, addExtraStep) {
        var index = indexRef.current;
        var nextInputValue = controlledValue[index];
        var otherValue = controlledValue[1 - index];
        var largeStep = (max - min) / (10 * step);
        var nextValueStep = clamp(nextInputValue + sign * (step * (addExtraStep ? largeStep : 1)));
        if (controlledValue.length <= 1 || thumbBehavior !== 'slide-through')
            return nextValueStep;
        // Buffer gap
        var minSteps = minStepsBetweenValues * step;
        var isBetweenMinStepsBuffer = Math.abs(nextValueStep - otherValue) < minSteps;
        // Continue with the next update if we still outside the buffer range.
        if (!isBetweenMinStepsBuffer) {
            return nextValueStep;
        }
        // Move the next value that's minSteps away from the fixed thumb.
        nextValueStep = clamp(otherValue + sign * minSteps);
        // If after updating nextValueStep and it's over the max
        // or under the min value, we need to clamp it. However,
        // This could cause the min step gap to not be respected, so
        // we should run a check again to see if we can actually update.
        if (Math.abs(nextValueStep - otherValue) === minSteps) {
            return nextValueStep;
        }
        // Otherwise, stay at the current value.
        return nextInputValue;
    };
    /**
     * Emulates input key presses that modify slider value(s).
     */
    var onKeyDown = function (event) {
        if (disabled)
            return;
        var key = event.key;
        var index = indexRef.current;
        switch (key) {
            case 'ArrowRight':
            case 'ArrowUp':
            case 'PageUp': {
                updateInput(getNextStep(SlideDirection.INCREASING, key === 'PageUp'), index, {
                    shouldCommit: true
                });
                event.preventDefault();
                break;
            }
            case 'ArrowLeft':
            case 'ArrowDown':
            case 'PageDown': {
                updateInput(getNextStep(SlideDirection.DECREASING, key === 'PageDown'), index, {
                    shouldCommit: true
                });
                event.preventDefault();
                break;
            }
            case 'Home': {
                updateInput(min, index, {
                    shouldCommit: true
                });
                event.preventDefault();
                break;
            }
            case 'End': {
                updateInput(max, index, {
                    shouldCommit: true
                });
                event.preventDefault();
                break;
            }
            default:
                break;
        }
    };
    /**
     * Sets up handler for a drag-like event on the slider or thumb.
     * @param closestIndex The closest index of a thumb relative to pointer position.
     * @returns
     */
    var onSlideStart = function (closestIndex) {
        return function (_a) {
            var _b;
            var clientX = _a.clientX, pointerId = _a.pointerId;
            if (disabled)
                return;
            previousValueRef.current = controlledValue;
            var index = closestIndex !== null && closestIndex !== void 0 ? closestIndex : getClosestIndexToUpdate(clientX);
            indexRef.current = index;
            (_b = thumbRefs.current[index]) === null || _b === void 0 ? void 0 : _b.setPointerCapture(pointerId);
            // Allows the input slider to be clicked and accordingly updates the value.
            updateInput(getPointerValue(clientX), index);
        };
    };
    /**
     * Updates the view when the slider is dragged while the pointer ID is in context.
     * @param closestIndex
     * @returns
     */
    var onSlideMove = function (closestIndex) {
        return function (_a) {
            var _b;
            var clientX = _a.clientX, pointerId = _a.pointerId;
            if (disabled)
                return;
            var index = closestIndex !== null && closestIndex !== void 0 ? closestIndex : getClosestIndexToUpdate(clientX);
            indexRef.current = index;
            if ((_b = thumbRefs.current[index]) === null || _b === void 0 ? void 0 : _b.hasPointerCapture(pointerId)) {
                updateInput(getPointerValue(clientX), index);
            }
        };
    };
    /**
     * Cleans-up handler when dragging ends.
     * @param closestIndex
     * @returns
     */
    var onSlideEnd = function (closestIndex) {
        return function (_a) {
            var _b, _c;
            var clientX = _a.clientX, pointerId = _a.pointerId;
            if (disabled)
                return;
            handleOnValueCommit();
            (_b = thumbRefs.current[indexRef.current]) === null || _b === void 0 ? void 0 : _b.focus();
            indexRef.current = closestIndex !== null && closestIndex !== void 0 ? closestIndex : getClosestIndexToUpdate(clientX);
            (_c = thumbRefs.current[indexRef.current]) === null || _c === void 0 ? void 0 : _c.releasePointerCapture(pointerId);
        };
    };
    var inputStyle = (0, react_1.useMemo)(function () {
        return ({
            '--slider-bg-color': (0, Slider_styles_1.fillGradientMixin)(disabled, withTrack ? sort(controlledValue).map(function (val) { return 100 * getFraction(val); }) : undefined)
        });
    }, [disabled, max, min, withTrack, controlledValue]);
    return ((0, jsx_runtime_1.jsxs)(Slider_styles_1.SliderRoot, __assign({}, getTestAttributes('slider'), { "data-testid": dataTestId('root'), className: (0, classnames_1.default)('slider__root', className) }, { children: [(0, jsx_runtime_1.jsx)(Slider_styles_1.SliderInput, __assign({ className: "slider__input", ref: sliderRef, style: inputStyle, onPointerDown: onSlideStart(), onPointerMove: onSlideMove(), onPointerUp: onSlideEnd(), "data-testid": dataTestId('track'), "aria-disabled": disabled }, { children: (0, jsx_runtime_1.jsx)(Slider_styles_1.SliderTrack, { "aria-disabled": disabled }) })), controlledValue
                .map(function (_, idx) { return idx; })
                .map(function (idx) { return ((0, jsx_runtime_1.jsx)(SliderThumb_1.SliderThumb, { className: "slider__thumb slider__thumb--".concat(idx), role: "slider", tabIndex: disabled ? undefined : 0, "aria-disabled": disabled, ref: function (node) {
                    if (node && !thumbRefs.current[idx]) {
                        thumbRefs.current[idx] = node;
                        moveThumbToValuePosition(controlledValue[idx], idx, node);
                    }
                }, onPointerDown: onSlideStart(idx), onPointerMove: onSlideMove(idx), onPointerUp: onSlideEnd(idx), onClick: function () {
                    sliderRef.current.focus();
                }, "data-testid": dataTestId("thumb-".concat(idx)), "aria-valuemin": min, onKeyDown: onKeyDown, "aria-valuemax": max, "aria-valuenow": controlledValue[idx], onFocus: function () {
                    indexRef.current = idx;
                } }, idx)); })] })));
});
